import axios from "axios";
import { Message } from "element-ui";
import router from "@root/router/index";
let urlMap = {
  dev: "https://wintogether-op-api-dev.gtech.asia",
  test: "https://wintogether-op-api-test.gtech.asia",
  dstest: "https://wintogether-op-api-test.gtechcloud.cn",
  "prod-cn": "https://wintogether-op-api.cn.gtech.asia"
};
let api_url = urlMap[window.__GTECH_VARIABLES_ENV__];

// 创建axios实例
const service = axios.create({
  baseURL: api_url, // api的base_url
  timeout: 15000 // 请求超时时间,
});

// request拦截器
const APP_NAME = process.env.APP_NAME;
service.interceptors.request.use(
  config => {
    const AuthToken = localStorage.getItem("AUTH-TOKEN-K-ONE-CN");
    const AppCODE = window.__GTECH_VARIABLES_MAIN_APP_CODE__;
    config.headers["Auth-Token"] = AuthToken;
    config.headers["appCode"] = AppCODE;
    config.headers["appVersion"] = "2.2.1";
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非0是抛错 结合业务进行修改
     */
    const res = response.data;
    if (res.code !== "0") {
      if (
        res.code === "speedbiz.error-user-auth-token" ||
        res.code === "speedbiz.empty-user-auth-token" ||
        res.code === "app-version-expire-error" ||
        res.code === "wtcn.invalid-user-auth-token"
      ) {
        localStorage.clear();
        sessionStorage.clear();
        return router.push("/login");
      }
      if (response.config.options.errorMessage) {
        Message.error({
          message: res.message,
          offset: 11,
          duration: 2000
        });
      }
      return Promise.reject(res);
    }
    return res;
  },
  error => {
    // 错误处理
    try {
      switch (error.response.status) {
        case 500:
          error.message = "服务器错误"; // 明确返回500
          break;
        case 404:
          error.message = "404"; // 明确返回404
          break;
        default:
          error.message = "其他错误"; // 其他错误code
      }
    } catch (e) {
      error.message = "链接超时"; // 超时 获取不到status
    }

    if (
      error.config &&
      error.config.options &&
      error.config.options.errorMessage
    ) {
      Message.error({
        message: error.message,
        offset: 11,
        duration: 2000
      });
    }
    return Promise.reject(error);
  }
);

const verifySign = function(param) {
  const constParams = {};
  const body = param || {};
  Object.assign(body, constParams);
  return body;
};

export function httpServer(url, params, options = { errorMessage: true }, method) {
  console.log(url, params);
  return service({
    url: url,
    method: method || "post",
    data: verifySign(params),
    options: options
  });
}

export const API_URL = api_url;
